import { useContext } from 'react';
import { CompanyFeaturesContext } from '.';
export const useCompanyFeatures = () => {
    const context = useContext(CompanyFeaturesContext);
    if (!context) {
        throw new Error('useCompanyFeatures hook must be used as a child to <CompanyFeaturesProvider />');
    }
    return context;
};
